export default function ($translate, $rootScope) {
    const loadEnums = () => {
        return {
            KEYS: {
                CLASSIFIER_VIEW: 'CLASSIFIER_VIEW',
                ROOM_VIEW: 'ROOM_VIEW',
                MY_EMPLOYEE_USER_RESULTS_REPORT_VIEW: 'MY_EMPLOYEE_USER_RESULTS_REPORT_VIEW',
                MY_EMPLOYEE_COURSE_PROGRESS_REPORT_VIEW: 'MY_EMPLOYEE_COURSE_PROGRESS_REPORT_VIEW',
                MY_EMPLOYEE_OCCURRENCE_VIEW: 'MY_EMPLOYEE_OCCURRENCE_VIEW',
                MY_EMPLOYEE_TRAINING_NEED_VIEW: 'MY_EMPLOYEE_TRAINING_NEED_VIEW',
                MY_EMPLOYEE_OCCURRENCE_PARTICIPANT_MANAGE: 'MY_EMPLOYEE_OCCURRENCE_PARTICIPANT_MANAGE',
                MY_EMPLOYEE_OCCURRENCE_PARTICIPANT_VIEW: 'MY_EMPLOYEE_OCCURRENCE_PARTICIPANT_VIEW',
                MY_EMPLOYEE_TRAINING_TIME_REGISTER: 'MY_EMPLOYEE_TRAINING_TIME_REGISTER',
                MY_EMPLOYEE_VIEW: 'MY_EMPLOYEE_VIEW'
            },
            LABELS: {
                CLASSIFIER_VIEW: $translate.instant('role.privilege.dm.classifierView'),
                ROOM_VIEW: $translate.instant('role.privilege.dm.roomView'),
                MY_EMPLOYEE_USER_RESULTS_REPORT_VIEW: $translate.instant('role.privilege.dm.myEmployeeUserResultsReportView'),
                MY_EMPLOYEE_COURSE_PROGRESS_REPORT_VIEW: $translate.instant('role.privilege.dm.myEmployeeCourseProgressReportView'),
                MY_EMPLOYEE_OCCURRENCE_VIEW: $translate.instant('role.privilege.dm.myEmployeeOccurrenceView'),
                MY_EMPLOYEE_TRAINING_NEED_VIEW: $translate.instant('role.privilege.dm.myEmployeeTrainingNeedView'),
                MY_EMPLOYEE_OCCURRENCE_PARTICIPANT_MANAGE: $translate.instant('role.privilege.dm.myEmployeeOccurrenceParticipantManage'),
                MY_EMPLOYEE_OCCURRENCE_PARTICIPANT_VIEW: $translate.instant('role.privilege.dm.myEmployeeOccurrenceParticipantView'),
                MY_EMPLOYEE_TRAINING_TIME_REGISTER: $translate.instant('role.privilege.dm.myEmployeeTrainingTimeRegister'),
                MY_EMPLOYEE_VIEW: $translate.instant('role.privilege.dm.myEmployeeView')
            }
        };
    };

    const enums = loadEnums();

    $rootScope.$on('$translateChangeSuccess', () => {
        enums.LABELS = loadEnums().LABELS;
    });
    return enums;
}



// WEBPACK FOOTER //
// ./src/app/enums/role/privilege/directManager/index.js